/**
 * @voltxampere/ui — Green LED 5mm (Sprint 51-1 polish, dedicated variant)
 *
 * Standard 5mm green LED — GaP, V_F ≈ 2.1V at 20mA. Used in status
 * indicators, traffic-light demos, "OK" signaling.
 *
 * Engine zero-diff invariant honored — schemaType `led`.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { led } from "../led.js";
export const ledGreen5mm = {
    id: "led-green-5mm",
    nameTr: "LED Yeşil 5mm (genel)",
    nameEn: "LED Green 5mm (generic)",
    shortcut: "D",
    category: "active",
    viewBox: led.viewBox,
    terminals: led.terminals,
    defaultLabel: "D",
    defaultValue: "GREEN",
    schemaType: "led",
    defaultParams: {
        is: 1e-12,
        n: 3,
        vForward: 2.1,
        color: "green",
        package: "T-1¾ (5mm)",
        wavelengthNm: 565,
        luminousIntensityMcd: 80,
    },
    renderSVG: () => led.renderSVG(),
};
//# sourceMappingURL=led-green-5mm.js.map